import React from "react";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";

import { PollutionParamsTableContainer } from "../AddEditSolution.styled";

const PollutionParameterTable = (props) => {
  const { data, t } = props;

  return (
    <PollutionParamsTableContainer>
      <table>
        <thead>
          <tr>
            <td>{t("SAMPLE_NAME")}</td>
            <td>{t("POLLUTION_PARAMS")}</td>
          </tr>
        </thead>
        <tbody>
          {data.map((param) => {
            return (
              <tr key={param.sample}>
                <td>{param.sample}</td>
                <td>
                  {param.messages.map((message) => {
                    return (
                      <div key={message.parameter}>
                        <span className="parameter-name">
                          {t(message.parameter)}
                        </span>
                        <span className="parameter-separator">:</span>
                        <span className="parameter-message">{`${message.parameterValue} > ${message.threshold}`}</span>
                      </div>
                    );
                  })}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </PollutionParamsTableContainer>
  );
};

PollutionParameterTable.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  t: PropTypes.func.isRequired,
};

export default withTranslation()(PollutionParameterTable);
